var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-checkbox',{attrs:{"label":_vm.label,"disabled":_vm.disabled,"error-messages":_vm.validationError},on:{"change":function($event){return _vm.$emit('change', $event)}},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }